// src/components/PolicyPage.js
import React from 'react';
import './PolicyPage.css'; // Create this CSS file for policy page specific styles

function PolicyPage({ title, lastUpdated, children }) {
  return (
    <div className="policy-container">
      <h1>{title}</h1>
      {/* {lastUpdated && <div className="last-updated">Last Updated: {lastUpdated}</div>} */}
      {children}
    </div>
  );
}

export default PolicyPage;
